import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeroAbout = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [rotateIcon, setRotateIcon] = useState(false);

  const toggleDrawer = () => {
    setRotateIcon(true);
    setOpen((prev) => !prev);
    setTimeout(() => setRotateIcon(false), 600);
  };

  const styles = {
    section: {
      position: 'relative',
      width: '100%',
      height: '60vh',
      background: '#0057A4',
    
      padding: '40px 20px',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    logoContainer: {
      position: 'absolute',
      top: 20,
      left: 20,
      width: 80,
      height: 80,
      cursor: 'pointer',
    },
    logo: {
      width: '100px',
      height: '100px',
      objectFit: 'contain',
    },
    imageContainer: {
      flex: '1 1 60%',
      textAlign: 'center',
    },
    image: {
      width: '100%',
      maxWidth: '700px',
      height: 'auto',
      transform: 'perspective(800px) rotateY(-2deg)',
    },
    textContainer: {
      flex: '1 1 35%',
      textAlign: 'center',
      color: '#fff',
    },
    text: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
    },
  };

  return (
    <Box component="section" sx={styles.section}>
      

      <Box sx={styles.imageContainer}>
        <img src="/image/AboutUs.png" alt="Building" style={styles.image} />
      </Box>

      <Box sx={styles.textContainer}>
        <Typography sx={styles.text}>{t('heroAbout.title')}</Typography>
      </Box>
    </Box>
  );
};

export default HeroAbout;
